import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export interface PurchasedProductsStateType {
    readonly byId: { [key: string]: PaginationModel };
    readonly loading: { [key: string]: boolean };
}
export type CustomPurchasedProductsState = Readonly<PurchasedProductsStateType>;
export const initialPurchasedProductsState: CustomPurchasedProductsState = {
    byId: {},
    loading: {},
};
export const customPurchasedProductsReducer = createTypedReducer(initialPurchasedProductsState, {
    "Custom/PurchasedProducts/BeginEndLoadProducts": (
        draft: Draft<CustomPurchasedProductsState>,
        { id, loading }: { id: string; loading: boolean },
    ) => ({
        ...draft,
        loading: {
            ...draft.loading,
            [id]: loading,
        },
    }),
    "Custom/PurchasedProducts/CompleteLoadProducts": (
        draft: Draft<CustomPurchasedProductsState>,
        { id, pagination }: { id: string; pagination: PaginationModel },
    ) => ({
        ...draft,
        byId: {
            ...draft.byId,
            [id]: pagination,
        },
    }),
});
